import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import cx from 'classnames';
import styles from './OMCheckboxDropdown.scss';
import isSameElement from '../../../helpers/isSameElement';

export default class OMCheckboxDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      pristine: this.checkPristine(props)
    };
  }

  componentDidMount() {
    document.body.addEventListener('click', this.bodyClickHandler);
  }

  componentWillReceiveProps({ value }) {
    if (this.state.pristine && (!this.props.value.length || this.props.value?.indexOf('all') !== -1) && value.length && value[0] !== 'all') {
      this.setState({ pristine: false });
    }
  }

  componentWillUnmount() {
    document.body.removeEventListener('click', this.bodyClickHandler);
  }

  bodyClickHandler = (evt) => {
    if (!this.state.isOpen) {
      return;
    }

    if (!isSameElement(this.node, evt.target)) {
      this.setState({ isOpen: false });
    }
  };

  handleOpen = (evt) => {
    evt.preventDefault(); // needs for mobile filters
    this.setState({ isOpen: !this.state.isOpen }, () => this.props.onOpen && this.props.onOpen(evt));
  };

  handleOptionClick = (evt) => {
    const dataTitle = evt.target.dataset.title;
    const result = !this.props.optionValueIsString && +dataTitle ? +dataTitle : dataTitle;
    const stateModifier = {};

    if (this.state.pristine) {
      stateModifier.pristine = false;
    }

    this.props.onChange(result);

    if (this.props.shouldCloseOnClick) {
      stateModifier.isOpen = false;
    }

    this.setState(stateModifier);
  };

  isDisabled = value => this.props.items ? get(this.props.items.find(v => v.name === value), 'disabled', false) : false;

  checkPristine = props => props.value && (!props.value.length || props.value[0] === 'all');

  render() {
    const {
      options,
      value,
      title,
      className,
      width,
      counterSelected,
      counterGeneral,
      titleContainerClassName
    } = this.props;

    return (
      <div
        className={cx(styles.wrapper, styles[className], 'om-checkbox-dropdown')}
        ref={(node) => { this.node = node; }}
        style={{ width: `${width}px` }}
      >
        <button
          className={this.props.items
            ? styles.columnsButton
            : cx(styles.button, { [styles.isOpen]: this.state.isOpen })}
          onClick={this.handleOpen}
        >
          {this.props.items
          ? <div className={styles.titleContainer}>
              <span className={styles.iconBlock}><i className="icon icon-setting-gears" /></span>
              <span className={styles.columnsTitle}>
                {`${title}: `}
                <span className={styles.counterSelected}>{ counterSelected }</span>
                {`/${counterGeneral}`}
              </span>
            </div>
          : <div className={titleContainerClassName}>
              <span className={cx(styles.title, { [styles.pristine]: this.state.pristine })}>{ title }</span>
              <span className={cx(styles.arrow, styles[`caret-${this.state.isOpen ? 'up' : 'down'}`])} />
            </div>}
        </button>
        { this.state.isOpen ?
          <ul className={this.props.items ? styles.columnSelect : styles.select}>
            { options.map(el =>
              (<li
                key={el.value}
                className={this.props.items
                  ? cx(styles.columnsOption)
                  : cx(styles.option, { [styles.selected]: (value.indexOf(el.value) !== -1) })}
              >
                <input
                  id={el.value}
                  data-title={el.value}
                  type="checkbox"
                  className={styles.checkbox}
                  value={el.value}
                  checked={value.indexOf(el.value) !== -1}
                  readOnly
                  disabled={this.isDisabled(el.value)}
                  onClick={this.handleOptionClick}
                />
                <label
                  htmlFor={el.value}
                >
                  { el.label }
                </label>
              </li>)
            ) }
          </ul> : null }
      </div>
    );
  }
}

OMCheckboxDropdown.propTypes = {
  options: PropTypes.array,
  title: PropTypes.string,
  onChange: PropTypes.func,
  onOpen: PropTypes.func,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array
  ]),
  items: PropTypes.array,
  className: PropTypes.string,
  shouldCloseOnClick: PropTypes.bool,
  width: PropTypes.number,
  counterSelected: PropTypes.number,
  counterGeneral: PropTypes.number,
  optionValueIsString: PropTypes.bool,
  titleContainerClassName: PropTypes.string
};
